<template>
  <pt-third-vendors class="pt-third-vendors__withData" :vendorTypes="vendorTypes"></pt-third-vendors>
</template>

<script>
import PtThirdVendors from './index'
export default {
  name: 'pt-third-vendors__withData',
  components: {
    'pt-third-vendors': PtThirdVendors
  },
  data () {
    return {
      vendorTypes: []
    }
  },
  methods: {
    getVendorType () {
      this.$store.dispatch('getVendorType').then(data => {
        this.vendorTypes = data.map(e => {
          return {
            label: e.name,
            value: e.value
          }
        })
      })
    }
  },
  created () {
    this.getVendorType()
  }
}
</script>
